import React, { useState } from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { useSucursal } from '../contexts/SucursalContext';
import { useUser } from '../contexts/UserContext';
import AperturaCajaDirecta from '../Arqueos/AperturaCajaDirecta';
import ConteoDenominacionesAlert from './ConteoDenominacionesAlert';

const CajaStatusAlert = ({ showActions = true, onIniciarCaja }) => {
    const { cajaAbierta, cajaAbiertaDatos, requiereConteo } = useSucursal();
    const { user } = useUser();
    const [showApertura, setShowApertura] = useState(false);

    const handleIniciarCaja = () => {
        if (onIniciarCaja) {
            // Si se pasa una función personalizada, usarla
            onIniciarCaja();
        } else {
            // Por defecto, usar el nuevo flujo de apertura directa
            setShowApertura(true);
        }
    };

    if (cajaAbierta) {
        return (
            <>
                <Alert severity="success" sx={{ mb: 2 }}>
                    <AlertTitle>Caja Abierta</AlertTitle>
                    Caja ID: {cajaAbiertaDatos} - Usuario: {user?.codigoUsuario}
                </Alert>
                
                {/* Mostrar alerta de conteo requerido si es necesario */}
                <ConteoDenominacionesAlert />
            </>
        );
    }

    return (
        <>
            <Alert 
                severity="warning" 
                sx={{ mb: 2 }}
                action={
                    showActions && (
                        <Button color="inherit" size="small" onClick={handleIniciarCaja}>
                            Iniciar Caja
                        </Button>
                    )
                }
            >
                <AlertTitle>Caja Cerrada</AlertTitle>
                Debe iniciar la caja antes de realizar operaciones de facturación o movimientos.
            </Alert>

            <AperturaCajaDirecta
                open={showApertura}
                onClose={() => setShowApertura(false)}
            />
        </>
    );
};

export default CajaStatusAlert;
